import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Form from '@/common/components/Form';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import TextArea from '@/common/components/TextArea';
import useMetaAccountForm from '../../hooks/useMetaAccountForm';

const MetaAccountForm = ({ setShow, account }) => {
	const hook = useMetaAccountForm({ setShow, account });

	return (
		<PopUp setShow={setShow}>
			<Form
				title={`${
					Object.keys(account).length > 0 ? 'Edit' : 'Create'
				} Meta Account`}
				onSubmit={(e) => hook.handleSubmit(e)}
			>
				<Input
					inputRef={hook.emailRef}
					value={account?.email}
					name='Email'
					type='email'
					color={Colors.darkBlue}
					width={70}
					requiredSign={true}
					placeholder='Insert email...'
				/>
				<TextArea
					textAreaRef={hook.accessTokenRef}
					defaultValue={account?.access_token}
					width={400}
					label='Token'
					requiredSign
					placeholder='Insert token...'
					required
				/>
				<SubmitButton
					text='Save'
					style={{ marginTop: '10px', marginLeft: 'auto' }}
				/>
			</Form>
		</PopUp>
	);
};

export default MetaAccountForm;
